'use client'

import type { ForgotPasswordConfirmationProps } from '@maestro/commerce-blocks/components/forgot-password/forgot-password.types'

import { useTranslations } from 'next-intl'

import { Button } from '@pearlconvert/ui/components/button'

export default function ForgotPasswordConfirmation({
  cmsBlock,
  onBackToLogin,
}: ForgotPasswordConfirmationProps) {
  const t = useTranslations('commerce-blocks')

  return (
    <div className="forgot-password">
      {cmsBlock}
      <Button type="primary" onClick={onBackToLogin}>
        {t('auth.forgot-password.confirmation.go-to-login')}
      </Button>
    </div>
  )
}
